import { useCallback, useState } from 'react';
import ChrModal from '../../../components/generic/Utils/ChrModal';
import ChrMountedModal from '../../../components/generic/Utils/ChrModal/Mounted';

const useChrModal = (props = {}) => {
  const { unmountOnHide = true } = props;
  const [show, setShow] = useState(false);
  const [isSoftHidden, setIsSoftHidden] = useState(false); // CSS based hiding without unmounting. Supported only for the ChrModal component.
  const showModal = () => setShow(true);
  const hideModal = () => setShow(false);
  const toggleSoftHiddenStatus = () => setIsSoftHidden(prev => !prev);

  const modalOptions = { show, showModal, hideModal, isSoftHidden };
  const modalControls = { showModal, hideModal, toggleSoftHiddenStatus };
  const modalComponent = unmountOnHide ? ChrModal : ChrMountedModal;

  return {
    ChrModal: modalComponent,
    modalOptions,
    modalControls
  };
};

export default useChrModal;
